module.exports = __webpack_public_path__ + "static/media/image-005n.d528f5be.jpeg";